import React, { useState } from "react";
import { Button, Grid, TextField, Typography } from "@material-ui/core";
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { DateTimePicker } from '@material-ui/pickers';
import { Formik } from "formik";
import moment from "moment";
import * as Yup from "yup";
import { useAlert } from "react-alert";
import PulseLoader from "react-spinners/PulseLoader";
import ReservationsService from "../../../services/reservations.service";
import { colors } from "../../../assets/theme";

const invitationSchema = Yup.object().shape({
  rut: Yup.string().required("Required field: rut cannot be empty"),
  startTime: Yup.date().required("Start time cannot be empty"),
  endTime: Yup.date()
    .required("End time cannot be empty")
    .test("is-greater", "End time should be greater than start time", function(value) {
      const { startTime } = this.parent;
      return moment(value, "HH:mm").isSameOrAfter(moment(startTime, "HH:mm"));
    }),
  useCommunityParking: Yup.boolean().default(false)
});

const initialValues = { rut: "", startTime: moment(new Date()), endTime: moment(new Date()), useCommunityParking: false };

const useMyState = (value) => {
  const [state, setState] = useState(value);
  const mySetState = cb => {
    return val => {
      setState(val);
      cb(val);
    }
  }
  return [state, mySetState];
};

const SendInvitationForm = ({ onCancel, onSubmit, formName }) => {
  const [startTime, handleStartTimeChange] = useMyState(moment(new Date()));
  const [endTime, handleEndTimeChange] = useMyState(moment(new Date()));
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={invitationSchema}
      onSubmit={(values, props) => {
        values = Object.assign({}, values, { startTime, endTime });
        onSubmit(values, props);
      }}

    >
      {({
        errors,
        handleChange,
        handleSubmit,
        values,
        setFieldValue,
        isSubmitting
      }) => {
        if (isSubmitting)
          return (
            <Grid
              container
              justify="center"
              alignItems="center"
              style={{ height: 200 }}
            >
              <PulseLoader color={colors.LOADING} />
            </Grid>
          );
        return (
          <>
            <Typography variant="h4" color="secondary">
              Send Invitation
            </Typography>
            <form onSubmit={handleSubmit}>
              <Grid
                container
                direction="row"
                spacing={6}
                justify="center"
                alignItems="center"
                >
                <Grid item>
                  <TextField
                    id="rut"
                    onChange={handleChange}
                    value={values.rut}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    type="text"
                    label="RUT"
                    helperText={errors && errors.rut}
                  />
                </Grid>
                <Grid item>
                  <DateTimePicker
                    variant="inline"
                    id="startTime"
                    label="Start Time"
                    value={values.startTime}
                    onChange={handleStartTimeChange(value => {
                      setFieldValue('startTime', value);
                      handleChange(value)
                    })}
                    helperText={errors && errors.startTime}
                    />
                </Grid>
                <Grid item>
                  <DateTimePicker
                    variant="inline"
                    id="endTime"
                    label="End Time"
                    value={values.endTime}
                    onChange={handleEndTimeChange(value => {
                      setFieldValue('endTime', value);
                      handleChange(value)
                    })}
                    helperText={errors && errors.endTime}
                  />
                </Grid>
                <Grid item>
                  <FormControlLabel
                    control={<Checkbox
                                color="primary"
                                id="useCommunityParking"
                                value={values.useCommunityParking}
                                onChange={handleChange}
                            />}
                    label="Use community parking"
                    labelPlacement="top"
                  />
                </Grid>
              </Grid>

              <Grid container justify="center">
                <Button
                  onClick={() => {
                    onCancel("showForm");
                    onCancel(formName);
                  }}
                  variant="contained"
                  color="secondary"
                  size="large"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="secondary"
                  size="large"
                >
                  Send
                </Button>
              </Grid>
            </form>
          </>
        );
      }}
    </Formik>
  );
};

const SendInvitation = ({ onCancel }) => {
  const alert = useAlert();
  const onSubmit = (values, { setSubmitting, resetForm }) => {
    ReservationsService.sendInvitation(values).then(reservation => {
        setSubmitting(false);
        resetForm(initialValues);
        alert.show("Registro exitoso!", { type: "success" });
      })
      .catch(err => {
        console.log('Error on invitation:', err);
        setSubmitting(false);
        alert.show(err.message, { type: "error" });
      });
  };
  return <SendInvitationForm onCancel={onCancel} onSubmit={onSubmit} formName="showSendInvitationForm" />
}

export default SendInvitation;
